import React from "react";
import fr from "@/content/fr";
import ResidencePage from "@/pages/ResidencePage";

export const StreetwearPage = () => (
  <ResidencePage content={fr.streetwear} idPrefix="streetwear" />
);

export default StreetwearPage;
